import * as D from '../../def';
export const annotation:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 9,
        },
      },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2019,
      //     month: 6,
      //     day: 28,
      //   },
      // },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 11,
          day: 26,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 16,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 9,
          day: 25,
        },
      },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 1,
      //     day: 8,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 2,
      //     day: 21,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 3,
      //     day: 14,
      //   },
      // },
      {
        color: 'green',
        date: {
          year: 2021,
          month: 5,
          day: 24,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 9,
        },
      },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2019,
      //     month: 6,
      //     day: 28,
      //   },
      // },
      {
        color: 'green',
        date: {
          year: 2019,
          month: 11,
          day: 26,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 16,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 9,
          day: 25,
        },
      },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 1,
      //     day: 8,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 2,
      //     day: 21,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 3,
      //     day: 14,
      //   },
      // },
      {
        color: 'green',
        date: {
          year: 2021,
          month: 5,
          day: 24,
        },
      },
    ],
  },
};